import { POSTS_AMOUNT_INSTAGRAM, POSTS_AMOUNT_TIKTOK } from 'modules/proposal/utils/creator-proposal-utils';

import type { ProposalTileChannelType, ProposalTileChannelTypeOptions } from 'modules/proposal/types/ProposalTile.type';
import type { ProposalCreatorProfile } from 'types';

type ChannelEntry = {
  channelId: number,
  channelType: ProposalTileChannelType
};

export function collectActiveChannels(
  creatorProfile: ProposalCreatorProfile,
  channelOptions: Array<ProposalTileChannelTypeOptions>,
  selectedChannels: Array<ProposalTileChannelType>,
  canHaveChannelsSelector: boolean
): Array<ChannelEntry> {
  return [
    {
      channelId: creatorProfile.channels.instagram?.id ?? 0,
      channelType: 'instagram' as ProposalTileChannelType
    }, {
      channelId: creatorProfile.channels.tiktok?.id ?? 0,
      channelType: 'tiktok' as ProposalTileChannelType
    }
  ].filter((entry) =>
    !!entry.channelId
    && channelOptions.includes(entry.channelType)
    && (selectedChannels.includes(entry.channelType) || !canHaveChannelsSelector)
  );
}

export function canResetPosts(
  channels: Array<ChannelEntry>,
  nonEmptyTTPosts: number,
  nonEmptyIGPosts: number
): boolean {
  return channels.reduce<boolean>((result, channel) => {
    if (channel.channelType === 'tiktok') {
      return result && nonEmptyTTPosts > 0;
    }

    if (channel.channelType === 'instagram') {
      return result && nonEmptyIGPosts > 0;
    }

    return result;
  }, true);
}

export function canAutofillPosts(
  channels: Array<ChannelEntry>,
  nonEmptyTTPosts: number,
  nonEmptyIGPosts: number
): boolean {
  return channels.reduce<boolean>((result, channel) => {
    if (channel.channelType === 'tiktok') {
      return result || nonEmptyTTPosts < POSTS_AMOUNT_TIKTOK;
    }

    if (channel.channelType === 'instagram') {
      return result || nonEmptyIGPosts < POSTS_AMOUNT_INSTAGRAM;
    }

    return result;
  }, false);
}
